import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_textile-excellence-1/artifacts/b4ez7ek9_Screenshot%202025-10-06%20at%203.26.30%E2%80%AFPM.png";
const INPUT_CLS = "rounded-none border-border py-5 font-sans text-sm";

async function authenticateAdmin({ username, password, isRegister }) {
  const endpoint = isRegister ? "/admin/register" : "/admin/login";
  const res = await axios.post(`${API}${endpoint}`, { username, password });
  return res.data;
}

function persistSession({ token, username }) {
  localStorage.setItem("admin_token", token);
  localStorage.setItem("admin_username", username);
}

function LoginForm({ username, setUsername, password, setPassword, loading, isRegister, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <Input
        data-testid="admin-username"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className={INPUT_CLS}
      />
      <Input
        data-testid="admin-password"
        placeholder="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className={INPUT_CLS}
      />
      <Button
        type="submit"
        disabled={loading}
        data-testid="admin-submit-btn"
        className="w-full bg-[#0F172A] text-white rounded-none py-5 text-xs uppercase tracking-[0.15em] font-sans hover:bg-[#0F172A]/90"
      >
        {loading ? "..." : isRegister ? "Create Account" : "Login"}
      </Button>
    </form>
  );
}

export default function AdminLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Please fill all fields");
      return;
    }
    setLoading(true);
    try {
      const data = await authenticateAdmin({ username, password, isRegister });
      persistSession(data);
      toast.success(isRegister ? "Account created!" : "Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="KF Prints" className="h-12 mx-auto mb-6" />
          <h1 className="text-2xl font-serif text-foreground">{isRegister ? "Create Admin Account" : "Admin Login"}</h1>
        </div>
        <LoginForm
          username={username}
          setUsername={setUsername}
          password={password}
          setPassword={setPassword}
          loading={loading}
          isRegister={isRegister}
          onSubmit={handleSubmit}
        />
        <button
          data-testid="admin-toggle-register"
          onClick={() => setIsRegister(!isRegister)}
          className="mt-6 text-xs font-sans text-muted-foreground hover:text-foreground block mx-auto"
        >
          {isRegister ? "Already have an account? Login" : "Need an account? Register"}
        </button>
      </div>
    </div>
  );
}
